import React from 'react';

const index = ({ onSubmit }) => {
  const buttonStyle = {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '15px 32px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
    margin: '4px 2px',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '4px',
    margintop: '10px'
  };

  const handleClick = (payload) => {
    // Your API call logic here
    console.log('Payment button clicked');
    onSubmit(payload);
  };

  return (
    <div>
      <center>
        <form
          style={buttonStyle}
          onClick={handleClick}
          // onClick={onSubmit}
        >
          {' '}
          payment{' '}
        </form>
      </center>
    </div>
  );
};

export default index;
